import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { S1Modal, S1ModalSizes, S1UIService } from '@app/s1';
import { IStazione } from '@app/shared/models/stazione';
import { IAssociaStazioneParams, TrattaService } from '@app/shared/services/tratta.service';

@Component({
  selector: 'ser-associa-stazione-modal',
  templateUrl: './associa-stazione-modal.component.html',
  styleUrl: './associa-stazione-modal.component.scss'
})
export class AssociaStazioneModalComponent {

  @Output() elementLinked = new EventEmitter<IStazione>();

  constructor(private trattaService: TrattaService, private ui: S1UIService) {}

  @ViewChild('modal') modal: S1Modal;

  idTratta: string; 

  open(idTratta: string) {
    this.idTratta = idTratta;
    this.modal.open(S1ModalSizes.LG);
  }

  close() {
    this.modal.close();
  }

  link(stazione: IStazione) {

    const params: IAssociaStazioneParams = {
      idTratta: this.idTratta,
      idStazione: stazione.id
    }

    this.trattaService.associaStazione(params).subscribe(success => {
      if (success) {
        this.ui.showSuccessToast("stazioni.messages.linked");
        this.elementLinked.emit(stazione);
        this.close();
      }
      
    })
    
  }

}
